import { IconsInitConfigType } from '@shared-ui-kit';

export interface TableComponentConfiguration {
  type?: string;
  smartLines?: boolean;
  columns: Record<string, TableFullColumns>;
}

export interface TableServerColumns {
  visible?: boolean;
  customWithCoefficient?: number;
  sort?: number;
}

export interface TableLocalColumns {
  minWidth?: number;
  sortingAvailable?: boolean;
  name?: string;
  icon?: IconsInitConfigType;
}

export interface TableFullColumns extends TableServerColumns, TableLocalColumns {}

export const TableModeType = {
  COMPACT: 'compact',
  ADVANCED: 'advanced',
} as const;

export type TableModeType = (typeof TableModeType)[keyof typeof TableModeType];
